/**
 * Records an authenticated app session server-side (UTC day bucket).
 * Fire-and-forget — failures are silent so observability never blocks UX.
 */

import { supabase } from "@/integrations/supabase/client";

let recordedForMount = false;

export function recordUserSession(): void {
  if (recordedForMount) return;
  recordedForMount = true;

  void supabase.rpc("record_user_session").then(({ error }) => {
    if (error) {
      console.warn("[recordUserSession] RPC failed:", error.message);
    }
  });
}

/** Test helper — allows a second record in the same page lifecycle. */
export function resetUserSessionRecordForTests(): void {
  recordedForMount = false;
}
